module.exports = __webpack_public_path__ + "static/media/top-left@2x.bb54d468.png";